module.exports = __webpack_public_path__ + "static/img/history__hovered.2e51489.svg";